import React from 'react';
import { Link, useLocation, useOutletContext, useSearchParams } from 'react-router-dom';
import { DateTime } from 'luxon';
import { DATESTR_FMT } from 'tdr-common';
import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { AvailabilityGuardContext, parseSearchParamsFilters } from '../../../routes/AvailabilityGuard';
import { analytics } from '../../../helpers/analytics';

export const MobileOpenSearchBar = () => {
	const { t, i18n } = useTranslation();
	const { restaurant } = useOutletContext<AvailabilityGuardContext>();
	const [searchParams] = useSearchParams();
	const location = useLocation();
	const filters = parseSearchParamsFilters(searchParams, restaurant?.timezone);
	const hasAny = !!(filters.groupSize || filters.date || filters.time);

	const summaryParts = hasAny
		? [
				filters.groupSize
					? `${filters.groupSize} ${filters.groupSize === 1 ? t('labels.guest', { defaultValue: 'guest' }).toLowerCase() : t('labels.guests', { defaultValue: 'guests' }).toLowerCase()}`
					: null,
				filters.date
					? DateTime.fromFormat(filters.date, DATESTR_FMT).setLocale(i18n.language === 'fr' ? 'fr-CA' : 'en').toLocaleString({ month: 'short', day: 'numeric' })
					: null,
				filters.time ? DateTime.fromFormat(filters.time, 'HH:mm').toFormat('h:mm a').toUpperCase() : null
			].filter(Boolean)
		: [];

	return (
		<Link
			to={{ pathname: 'filters', search: location.search }}
			onClick={() => analytics.track('Top Bar Search Clicked', { source: 'open_parameters' })}
			className="flex h-[62px] w-full items-center gap-2 rounded-2xl border border-white/10 bg-[#2f3238] px-4"
		>
			<Search size={20} className="shrink-0 text-header-icon-yellow" strokeWidth={2} />
			{summaryParts.length > 0 ? (
				<span className="inline-flex min-w-0 flex-1 flex-wrap items-center gap-x-2 text-sm font-semibold text-white">
					{summaryParts.map((part, i) => (
						<React.Fragment key={i}>
							{i > 0 ? (
								<span className="inline-flex shrink-0 items-center justify-center px-px" aria-hidden>
									<span className="h-1.5 w-1.5 rounded-full bg-white/40" />
								</span>
							) : null}
							<span>{part}</span>
						</React.Fragment>
					))}
				</span>
			) : (
				<span className="text-sm font-semibold text-white">{t('actions.search', { defaultValue: 'Search' })}</span>
			)}
		</Link>
	);
};
